var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',_vm._b({staticClass:"panel-wrapper"},'b-col',_vm.container,false),[_c('section',[_c('b-row',[_c('b-col',[_vm._t("header")],2)],1)],1),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }